import React, { useState } from "react";

import "./CreateMcpServerDialog.scss";
import ModalDialog from "../../shared/ModalDialog";

const CreateMcpServerDialog = ({ onClose }) => {
  return (
    <ModalDialog
      onClose={onClose}
      className="create_campaign_dialog create_mcp_server_dialog"
    ></ModalDialog>
  );
};

export default CreateMcpServerDialog;
